import { useAuthModal } from 'authOld/hooks';
import { IAuthUser } from 'authOld/types';

import NavigationView from './NavigationView';

const Navigation = ({ user }: { user?: IAuthUser }) => {
  const { openAuthModal } = useAuthModal();

  return (
    <NavigationView
      isLoggedUser={Boolean(user)}
      openAuthModal={openAuthModal}
      userResources={user?.resources}
    />
  );
};

export default Navigation;
